module.exports = __webpack_public_path__ + "static/img/slider-2.c45ea3e5.png";